import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  async getAll($) {
    const path = `/activity/user-coupons`
    let results = (await HTTP.get(path)).data
    return results
  },

  async get(actionId) {
    const path = `/activity/user-coupons/${actionId}`
    return (await HTTP.get(path)).data
  },

  async post(notification_object) {
    return new Promise((resolve, reject) => {
      HTTP.post(`activity/user-coupons`, notification_object)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async authorize(couponId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`activity/user-coupons/${couponId}/approved`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async reject(couponId) {
    return new Promise((resolve, reject) => {
      HTTP.post(`activity/user-coupons/${couponId}/rejected`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },

  async put(data) {
    const { id, ...others } = data
    const path = `/activity/user-coupons/${id}`
    return (await HTTP.put(path, others)).data
  },

  async delete(actionId) {
    const path = `/activity/user-coupons/${actionId}`
    return (await HTTP.delete(path)).data
  }
}
